export const FrameImageFormat = {
  Undefined: 0,
  Jpeg: 1,
  Png: 2,
} as const;

export type FrameImageFormatValue =
  (typeof FrameImageFormat)[keyof typeof FrameImageFormat];

export type LiveFrameHeader = {
  format: FrameImageFormatValue;
  eye: number;
  capturedAt: number;
  relayedAt: number | null;
  sequence: number;
};

export type DecodedLiveFrame = {
  header: LiveFrameHeader;
  payload: ArrayBuffer;
};

export type LiveViewConnectionState =
  | "idle"
  | "connecting"
  | "open"
  | "closed"
  | "error";

export type StreamAddress = {
  clinicId: string;
  deviceId: string;
};
